import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-popup-internalreferred-validateemail',
  templateUrl: './popup-internalreferred-validateemail.component.html',
  styleUrls: ['./popup-internalreferred-validateemail.component.sass']
})
export class PopupInternalreferredValidateemailComponent implements OnInit {
  public screenActual=1;
  public emailReceiver;
  constructor(public matDialogRef:MatDialogRef<PopupInternalreferredValidateemailComponent>,public dialog: MatDialog, private services: Service, private global: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any,) {
    if(data.emailReceiver!=undefined){
      this.emailReceiver=data.emailReceiver;
    }
   }
 
  ngOnInit() {
  }
  public resetView(){
    this.matDialogRef.close('cancel');
  }
}
